import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34cf03d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toasts" }
const _hoisted_2 = { class: "toasts_label word_break" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "toasts_close_icon" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import store from '@/store';
import { Toast } from '@/store/modules/toasts';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Toasts',
  setup(__props) {

const toasts = computed(() => store.getters['toasts/toasts']);

const isAnimation = (toast: Toast) => {
  return toast.duration > 0 && isFinite(toast.duration);
};

const closeToast = (toastId: Toast['toastId']) => {
  store.commit('toasts/removeToast', toastId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      class: "toasts_inner",
      role: "status",
      "alia-live": "polite",
      tag: "div",
      name: "toasts"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["toasts_item", { animation: isAnimation(toast) }]),
            key: toast.toastId
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(toast.label), 1),
            _createElementVNode("button", {
              class: "toasts_close_button",
              type: "button",
              "aria-label": "閉じる",
              onClick: ($event: any) => (closeToast(toast.toastId))
            }, _hoisted_5, 8, _hoisted_3)
          ], 2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})